import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import { Link } from "@app/components/order/LinkList/LinkList"
import { useGetLinks, useGetStrings, useGetZone } from "@app/store/service/cmsService"
import { useGetPricesPerZone } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { LinkTypes } from "@app/utils/constants"
import { getPriceString, getTimeString } from "@app/utils/localeUtils"
import { classNamez } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import Skeleton from "react-loading-skeleton"

const getLinkUrl = linkData => {
	if (appStore.get("core.kioskMode")) return linkData.kioskBaseUrl
	return linkData.baseUrl
}

const ZoneDetailInformation = ({ zoneId }) => {
	const { data } = useGetZone(zoneId, { defaultData: [] })
	const { data: linkData, isLoading: linkLoading } = useGetLinks(undefined)
	const showOpeningHours = useSelector(state => state.settings.showOpeningHours ?? true)
	const { ageLabel, ageValue, openinghoursLabel, openinghoursRepeater, priceLabel, zoneAccessLabel, zoneAccessValue } = data
	const {
		data: { from, zoneSelectionSpecialOpeninghours },
	} = useGetStrings(undefined, { defaultData: {} })

	const { data: visitorKindsData } = useGetPricesPerZone()

	let visitorKinds = visitorKindsData && data && visitorKindsData.find(e => e.zoneId === data.zoneId)
	visitorKinds = visitorKinds ? visitorKinds.timeBlockKinds || [] : []

	return (
		<>
			<div className="mb-4 zoneDetailContainer age">
				<h4 className="regular f4">{ageLabel ? ageLabel : <Skeleton />}</h4>
				<div style={{ width: "100%", height: "2px" }} className="color-bg-primary mt-2" />
				<div className="color-fg-primary zoneDetail f5">{ageValue ? <MultilineText>{ageValue}</MultilineText> : <Skeleton />}</div>
			</div>
			<div className="mb-5 zoneDetailContainer hours">
				<h4 className="regular">{openinghoursLabel ? openinghoursLabel : <Skeleton />}</h4>
				<div style={{ width: "100%", height: "2px" }} className="color-bg-primary mt-2" />
				<div className="zoneDetail f5">
					{openinghoursRepeater && showOpeningHours
						? openinghoursRepeater.map((e, i) => {
								return (
									<DateRow
										from={e.openinghoursFrom}
										to={e.openinghoursTo}
										isSecondary={e.className === "secondary"}
										isYellow={e.className === "yellow"}
										label={e.openinghoursLabel}
										suffix={e.openinghoursSuffix}
										value={e.openinghoursValue}
										key={i}
									/>
								)
							})
						: null}

					{!appStore.get("core.kioskMode") && (
						<div>
							{linkLoading && <Skeleton />}
							{!linkLoading && linkData && (
								<Link
									noItalic
									href={getLinkUrl(linkData) + appStore.get("core.languageCode") + "/" + linkData.links.find(e => e.type === LinkTypes.openingHours).slug}
								>
									{zoneSelectionSpecialOpeninghours}
								</Link>
							)}
						</div>
					)}
				</div>
			</div>
			<div className="mb-4 zoneDetailContainer price">
				<h4 className="regular f4">{priceLabel ? priceLabel : <Skeleton />}</h4>
				<div style={{ width: "100%", height: "2px" }} className="color-bg-primary mt-2" />
				<div className="zoneDetail f5">
					{visitorKinds &&
						visitorKinds.map((e, i) => {
							return (
								<div className="flex flex-justify-between mb-2" key={i}>
									<span>{e.timeBlockKind}</span>
									<span style={{ whiteSpace: "nowrap" }}>
										{from} {getPriceString(e.minPrice, undefined, data.roundPrices)}
									</span>
								</div>
							)
						})}
				</div>
			</div>
			{zoneAccessValue && (
				<div>
					<h4 className="regular">{zoneAccessLabel ? zoneAccessLabel : <Skeleton />}</h4>
					<div style={{ width: "100%", height: "2px" }} className="color-bg-primary mt-2 " />
					<div className={zoneAccessValue.length > 1 ? "mb-4 zoneDetail" : "mb-4"}>
						{zoneAccessValue ? <MultilineText className="f5">{zoneAccessValue}</MultilineText> : <Skeleton />}
					</div>
				</div>
			)}
		</>
	)
}

const DateRow = ({ label, from, to, value, suffix, isSecondary, isYellow }) => {
	let fromDate = from ? new Date(Date.parse("01 Jan 1970 " + from)) : null
	let toDate = to ? new Date(Date.parse("01 Jan 1970 " + to)) : null
	const locale = useSelector(state => state.core.locale)
	return (
		<div className="flex flex-justify-between mb-2">
			<span>{label}</span>
			<span className={classNamez({ "color-fg-secondary": isSecondary, "color-fg-attention": isYellow })} style={{ whiteSpace: "nowrap" }}>
				{value ? (
					value
				) : (
					<>
						{getTimeString(fromDate)} - {getTimeString(toDate)} {locale === "de-DE" ? suffix : ""}
					</>
				)}
			</span>
		</div>
	)
}

export { ZoneDetailInformation }
